import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NodeComponent } from './node.component';
import { ConditionNodeComponent } from './condition-node/condition-node.component';
import { MatFormFieldModule, MatSelectModule, MatInputModule, MatButtonModule, MatIconModule } from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule,
		DragDropModule,
		FormsModule,
		MatButtonModule,
		MatIconModule
	],
	exports: [NodeComponent],
	declarations: [NodeComponent, ConditionNodeComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class NodeModule {}
